import React from 'react';
import {withTranslation} from "react-i18next";

let OrderPropertyComponent = ({labelKey, value, smWidth, lgWidth, t, labelSuffix=''}) => {
	return <div className={`col-sm-${smWidth} col-lg-${lgWidth} order-detail-card`}>
		<div className="order-detail">
			<div className="order-detail-label">
				{t(labelKey)}{labelSuffix}
			</div>
			<div className="order-detail-value">
				{value}
			</div>
		</div>
	</div>
};

export default withTranslation() (OrderPropertyComponent)